var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      {
        staticClass: "projects-lite-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.showModal("modal-request-custom-design")
          }
        }
      },
      [
        _c("SVGStepsProjects", {
          staticClass: "lb-svg",
          attrs: { id: "svg-send-photo" }
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Отправить своё фото на визуализацию")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }